import PageNotFound from '../layouts/PageNotFound.vue'
import { ApiKeyManagementRoutes } from './api-key-management'
import { authRoutes } from './auth'
import { BanksRoutes } from './banks'
import { BenefitRoutes } from './benefits'
import { CalculatePhasesRoutes } from './calculate-phases'
import { CalendarRoutes } from './calendars'
import { CapsRoutes } from './caps'
import { CityRoutes } from './cities'
import { CompanyRoutes } from './companies'
import { ContractTypesRoutes } from './contract-types'
import { CostCenterRoutes } from './cost-centers'
import { CountryRoutes } from './countries'
import { CountryParameterRoutes } from './country-parameters'
import { CurrencyRoutes } from './currencies'
import { dashboardRoutes } from './dashboard'
import { DepartmentRoutes } from './departments'
import { DirectionRoutes } from './directions'
import { dynamicRoutes } from './dynamic-form'
import { EducationLevelRoutes } from './education-levels'
import { SavedFormulaRoutes } from './saved-formulas'
import { ProcessedPayrollsRoutes } from './processed-payrolls'
import { ValidationRoutes } from './validations'
import { ImportRequestsRoutes } from './import-requests'
import { TransferRequestsRoutes } from './transfer-requests'
import { IncreaseSalaryRequestsRoutes } from './increase-salary-requests'
import { CopyPayrollRequestRoutes } from './payroll-copy-requests'
import { ReportsRoutes } from './reports'
import { PayrollSheetRoutes } from './payroll-sheet'
import { ReceiptTemplatesRoutes } from './receipt-templates'
import { LiquidationRequestRoutes } from './liquidation'
import { ReversePayrollsRoutes } from './reverse-payrolls'
import { VacationAccumulationRequestsRoutes } from './vacation-accumulation-requests'
import { PayrollReceipts } from './payroll-receipts'
import { SubscriptionManagementRoutes } from './subscriptions-management'
import { EmployeeTypeRoutes } from './employee-types'
import { EmployeesRoutes } from './employees'
import { EntityRoutes } from './entities'
import { ExchangeRateRoutes } from './exchange-rates'
import { FiscalRuleRoutes } from './fiscal-rules'
import { GovernmentNewsRoutes } from './government-news'
import { IdentificationTypeRoutes } from './identification-types'
import { IncidentRoutes } from './incidents'
import { IncreaseReasonsRoutes } from './increase-reasons'
import { JoiningReasonsRoutes } from './joining-reasons'
import { JourneyRoutes } from './journeys'
import { LeaveReasonRoutes } from './leave-reasons'
import { AccountRoutes } from './ledger-accounts'
import { LicenseTypeRoutes } from './license-types'
import { LicenseRequestRoutes } from './licenses'
import { ListHolidayRoutes } from './list-holidays'
import { LoansRoutes } from './loans'
import { LocationRoutes } from './locations'
import { ManagementRoutes } from './managements'
import { MasterConceptRoutes } from './master-concepts'
import { PayrollConceptRoutes } from './payroll-concepts'
import { PayrollRoutes } from './payrolls'
import { PendingProcessesRoutes } from './pending-processes'
import { PositionRoutes } from './positions'
import { ProcessesRoutes } from './processes'
import { RecurringIncidentRoutes } from './recurring-incidents'
import { RoleRoutes } from './roles'
import { StatesRoutes } from './states'
import { TurnRoutes } from './turns'
import { UserRoutes } from './users'
import { VacationBalanceRoutes } from './vacation-balance'
import { VacationPolicyRoutes } from './vacation-policy'
import { VacationRequestRoutes } from './vacation-request'

export const featureRoutes = [
  {
    path: '/',
    redirect: '/login'
  },
  ...authRoutes,
  ...dashboardRoutes,
  ...UserRoutes,
  ...dynamicRoutes,
  ...CurrencyRoutes,
  ...CostCenterRoutes,
  ...PositionRoutes,
  ...IdentificationTypeRoutes,
  ...MasterConceptRoutes,
  ...DepartmentRoutes,
  ...ManagementRoutes,
  ...DirectionRoutes,
  ...CompanyRoutes,
  ...JourneyRoutes,
  ...StatesRoutes,
  ...CityRoutes,
  ...RoleRoutes,
  ...CountryRoutes,
  ...CountryParameterRoutes,
  ...TurnRoutes,
  ...LocationRoutes,
  ...PayrollConceptRoutes,
  ...CapsRoutes,
  ...AccountRoutes,
  ...PayrollRoutes,
  ...BanksRoutes,
  ...RecurringIncidentRoutes,
  ...ListHolidayRoutes,
  ...ExchangeRateRoutes,
  ...CalendarRoutes,
  ...VacationRequestRoutes,
  ...VacationBalanceRoutes,
  ...VacationPolicyRoutes,
  ...LoansRoutes,
  ...EntityRoutes,
  ...IncidentRoutes,
  ...LicenseTypeRoutes,
  ...LicenseRequestRoutes,
  ...CalculatePhasesRoutes,
  ...EmployeeTypeRoutes,
  ...JoiningReasonsRoutes,
  ...LeaveReasonRoutes,
  ...EmployeesRoutes,
  ...PendingProcessesRoutes,
  ...IncreaseReasonsRoutes,
  ...EducationLevelRoutes,
  ...ProcessedPayrollsRoutes,
  ...ValidationRoutes,
  ...SavedFormulaRoutes,
  ...ImportRequestsRoutes,
  ...TransferRequestsRoutes,
  ...ReportsRoutes,
  ...PayrollSheetRoutes,
  ...IncreaseSalaryRequestsRoutes,
  ...CopyPayrollRequestRoutes,
  ...ReceiptTemplatesRoutes,
  ...LiquidationRequestRoutes,
  ...ReversePayrollsRoutes,
  ...VacationAccumulationRequestsRoutes,
  ...PayrollReceipts,
  ...ApiKeyManagementRoutes,
  ...SubscriptionManagementRoutes,
  ...GovernmentNewsRoutes,
  ...BenefitRoutes,
  ...FiscalRuleRoutes,
  ...ProcessesRoutes,
  ...ContractTypesRoutes,
  ...JoiningReasonsRoutes,
  { path: '/:pathMatch(.*)*', component: PageNotFound }
]
